import { render, staticRenderFns } from "./SignSet.vue?vue&type=template&id=151172a5&scoped=true&"
import script from "./SignSet.vue?vue&type=script&lang=js&"
export * from "./SignSet.vue?vue&type=script&lang=js&"
import style0 from "./SignSet.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SignSet.vue?vue&type=style&index=1&id=151172a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151172a5",
  null
  
)

export default component.exports